export const TEST_EMAIL = 'user@mail.com';
export const FAIL_EMAIL = 'fail@mail.com';
export const TEST_PASSWORD = 'Password1';
export const FAIL_PASSWORD = 'FailureWord1';
export const RECAPTCHA_DEV = '6LfcvR0bAAAAALeCZHjnJHEA7lq0-6O4lbAR1oI4';
